import { TestWebinarBadge } from '@core/ui';
import { useAppSelector } from '@online-webinar/store';

/**
 * The title in the broadcast bar, with the test-webinar badge inline in front of it so the marker
 * costs the bar no extra height. The badge and the title share a row here rather than in
 * WebinarBasicInfo: the row is what makes the title need `truncate` on its own span and the badge
 * need `flex-none`, and keeping all three together keeps that relationship visible.
 */
export const BroadcastTitle = () => {
    const title = useAppSelector((state) => state.liveWebinar.webinarData.title);
    const isTest = useAppSelector((state) => state.liveWebinar.webinarData.isTest);

    return (
        <div className="font-medium font-accent sm:text-lg lg:text-xl leading-tight flex items-center gap-2">
            {isTest && <TestWebinarBadge classNames="flex-none" />}
            <span className="truncate">{title}</span>
        </div>
    );
};
